import Vue from "vue";
import i18nPlugin from "../plugins/i18n";
import translations from "./translations.json";

Vue.use(i18nPlugin, {
	translations,
});
